import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import "@styles/readers.scss";

import { Div, Icon } from "@components/Generics.react";

export default function IframeReader(props) {
    const { deck, closeDeck, recordAttempt } = props;
    const { t } = useTranslation("common");

    //---------------------------------------------------------------------------
    // Completion Tracking
    //---------------------------------------------------------------------------
    useEffect(() => {
        recordAttempt({
            viewedPercentage: 100,
            completion: true,
            pointsDelta: 0,
            score: null,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // ========================= Render Function =================================
    return (
        <Div fluid fullht minHt="60vh" rounded>
            <iframe
                className="iframe-container"
                title="This is an iframe Readertype"
                src={deck?.content}
                width={"100%"}
                height={"60vh"}
            />
            <Div className="close-icon" onClick={closeDeck}>
                {t("deck.close")} <Icon name="close" inline fitted />
            </Div>
        </Div>
    );
}
